import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatCheckboxModule, MatProgressSpinnerModule, MatMenuModule, MatButtonModule } from '@angular/material';
import { InputValidateDirective, ReadFileDirective } from './directives/util/util.directive';
import { AppHeaderComponent } from './components/app-header';
import { AppFooterComponent } from './components/app-footer';
import { AppButtonViewComponent } from './components/app-view-img/app-view-img.component';

@NgModule({
  imports: [
      CommonModule,
      MatMenuModule,
      MatButtonModule,
      MatProgressSpinnerModule,
      MatCheckboxModule
   ],
  declarations: [
       AppHeaderComponent, 
       AppFooterComponent,
       AppButtonViewComponent,
       InputValidateDirective, 
       ReadFileDirective
  ],
  exports: [
      AppHeaderComponent, 
      AppFooterComponent,
      AppButtonViewComponent,
      InputValidateDirective, 
      ReadFileDirective
  ]
})
export class SharedModule {}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/shared.module.ts